import { Grid } from '@mui/material';
import Card1 from './xs_mobile_components/Card1';
import Card2 from './xs_mobile_components/Card2';
import Card3 from './xs_mobile_components/Card3';
import Card4 from './xs_mobile_components/Card4';
import Card5 from './xs_mobile_components/Card5';
import Card6 from './xs_mobile_components/Card6';
import Navbar from './xs_mobile_components/NavBar';
import MenuDrawer from './xs_mobile_components/MenuDrawer';
import { useState } from 'react';

const sxGrid = {
  maxWidth: "100vw",
  backgroundSize: 'cover',
  backgroundPosition: "bottom",
  height: '100vh',
  position: 'relative',
  zIndex: 0,
};


function AppMobileXS(props) {

  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <Navbar open={() => setMenuOpen(true)} />
      <MenuDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Grid container sx={{ width: '100vw', position: 'relative', zIndex: 0 }}>
        <Grid id="title"  item size={12} sx={{ backgroundImage: "url(/assets/mobile/Card_1.png)", ...sxGrid }}>
          <Card1 />
        </Grid>
        <Grid id="presentazione" item size={12} sx={{ backgroundImage: "url(/assets/mobile/Card_2.png)", ...sxGrid, backgroundPositionY: "top" }}>
          <Card2 />
        </Grid>
        <Grid id="cosa-faremo" item size={12} sx={{ ...sxGrid, height: null, width: "100vw" }}>
          <Card3 />
        </Grid>
        <Grid id="quando-rivolgersi" item size={12} sx={{ ...sxGrid, height: null, backgroundColor: '#527180' }}>
          <Card4 />
        </Grid>

        <Grid id="contatti" item size={12} sx={{ ...sxGrid, height: null }}>
          <Card5 />
        </Grid>
        <Grid item size={12} sx={{ ...sxGrid, height: null, backgroundColor: '#527180' }}>
          <Card6 />
        </Grid>
      </Grid>
    </>
  );
}


export default AppMobileXS;
